import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FileText, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const links = [
    { to: "/#documente", label: "Documente" },
    { to: "/cum-functioneaza", label: "Cum funcționează" },
    { to: "/intrebari-frecvente", label: "Întrebări frecvente" },
  ];
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-md bg-white/95 dark:bg-slate-900/95 border-b border-slate-200/80 dark:border-slate-800"
    >
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-blue-600 text-white">
              <FileText className="w-5 h-5" />
            </span>
            <span className="font-heading font-extrabold text-xl tracking-tight text-slate-900 dark:text-white">
              ActeSimplu
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.to}
                href={l.to}
                data-testid={`nav-${l.label}`}
                className="text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-blue-600 transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <Button
              data-testid="header-cta"
              onClick={() => navigate("/#documente")}
              className="rounded-full bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6"
            >
              Începe
            </Button>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-slate-700 dark:text-slate-200"
            onClick={() => setOpen(!open)}
            aria-label="Meniu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 px-4 py-4 space-y-3">
          {links.map((l) => (
            <a
              key={l.to}
              href={l.to}
              onClick={() => setOpen(false)}
              className="block py-2 text-slate-700 dark:text-slate-200 font-medium"
            >
              {l.label}
            </a>
          ))}
          <Button
            data-testid="mobile-header-cta"
            onClick={() => {
              setOpen(false);
              navigate("/#documente");
            }}
            className="w-full rounded-full bg-blue-600 hover:bg-blue-700 text-white font-semibold"
          >
            Începe
          </Button>
        </div>
      )}
    </header>
  );
};
